import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

const Spinner: FC<PropsWithChildren<{
  spin: boolean;
}>> = ({ spin = false, children }) => {
  if (!spin) {
    return <>{children}</>;
  }

  return (
    <StyledSpinnerWrapper>
      <StyledSpinnerBackdrop />

      <StyledSpinnerContainer>
        <StyledSpinner viewBox="0 0 50 50">
          <circle
            className="path"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="2"
          />
        </StyledSpinner>
      </StyledSpinnerContainer>

      {children}
    </StyledSpinnerWrapper>
  );
};

const StyledSpinnerWrapper = styled.div`
  position: relative;
  pointer-events: none;
`;

const StyledSpinnerBackdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.15);
`;

const StyledSpinnerContainer = styled.div`
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const StyledSpinner = styled.svg`
  animation: rotate 1s linear infinite;
  margin: 40px;
  width: 50px;
  height: 50px;

  & .path {
    stroke: #e54910;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export default Spinner;
